import PreferencesPaneTogglesField from "./PreferencesPaneTogglesField";

export * from "./typings";
export default PreferencesPaneTogglesField;
export { PreferencesPaneTogglesField };
